import { Box, Flex } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface SidebarLayoutProps {
  sidebar: ReactNode;
  children: ReactNode;
}

export const SidebarLayout = ({ sidebar, children }: SidebarLayoutProps) => {
  return (
    <Flex
      backgroundColor="surfaceSecondaryFill"
      padding={{ base: 2, md: 4 }}
      direction={{ base: 'column', md: 'row' }}
    >
      {sidebar && (
        <>
          {/* Mobile: stacked above content */}
          <Box
            display={{ base: 'block', md: 'none' }}
            bgColor="surfacePrimaryFill"
            p={3}
            mb={3}
            borderRadius="10px"
          >
            {sidebar}
          </Box>

          {/* Desktop: fixed sidebar */}
          <Box
            display={{ base: 'none', md: 'block' }}
            width="270px"
            position="fixed"
            height="calc(100vh - 172px)"
            bgColor="surfacePrimaryFill"
            p={3}
            overflowY="auto"
            borderRadius="10px"
            flex={1}
        >
            {sidebar}
          </Box>
        </>
      )}

      <Box flex={1} ml={{ base: 0, md: sidebar ? '285px' : '0px' }}>
        {children}
      </Box>
    </Flex>
  );
};
